module.exports = __webpack_public_path__ + "media/images/bundleImage2-693f0be6.png";